import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

export default new Vuetify({
    theme: {
        themes: {
            light: {
                btAccessibility: '#424242',
                vermelho_corpore: '#BD2730',
                cinza_corpore: '#676C72',
                preto: '#000000',
                blueCorp: '#0075FF',
                primary: '#0075FF',
                azul: '#0075FF'
            },
            dark: {
                blueCorp: '#0075FF',
            }
        },
    },
})